export const FULL_SCREEN_DIALOG_ID = 'fullscreen';
